import { 
    ACTUALIZAR_LIST_PROCEDIMIENTO,
    AGREGAR_PROCEDIMIENTO,
  } from "./procedimientoActions";

  const procedimientoReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_PROCEDIMIENTO: {
            return {
                ...state,
                procedimientoList: action.payload
            }
        };

        case AGREGAR_PROCEDIMIENTO:{
            return {
                 ...state,
                 procedimientoList: [action.payload, ...state.procedimientoListList]
             }
         };

        default:
            return state;

    }
  }

  export default procedimientoReducer;